import { useMountAnimation } from '@/hooks/use-mount-animation';
import { clampPercent } from '@/lib/format';
import { cn } from '@/lib/utils';

/*
 * The prototype's progress bar: an inset bevel well with a solid green fill
 * that animates 0→target on mount (width 1.1s). Used for goal progress, XP
 * bars, etc.
 */
interface ProgressBarProps {
  /** Target fill 0–100. */
  value: number;
  /** Bar height in px. */
  height?: number;
  /** Accessible label; falls back to a generic "progress". */
  label?: string;
  className?: string;
}

export function ProgressBar({ value, height = 10, label, className }: ProgressBarProps) {
  const mounted = useMountAnimation();
  const target = clampPercent(value);

  return (
    <div
      className={cn('bevel-in bg-bar-bg w-full overflow-hidden', className)}
      style={{ height }}
      role="progressbar"
      aria-valuenow={target}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label ?? 'Progress'}
    >
      <div
        className="bg-bar-fill h-full transition-[width] duration-1000 ease-out"
        style={{ width: `${mounted ? target : 0}%` }}
      />
    </div>
  );
}
